import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { UserTicket }                                      from 'Domain/Models';

export const getUserTickets = (state: TRootState, filter: null | IFilterProps<UserTicket> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<UserTicket>;
  }

  return filterObjectStore(state.userTicket.entries, filter);
};
